const kamanoUpdateAccountLinks = () => {
  const accountLinks = document.querySelectorAll('.header-utility-link--account[href="/account"]');
  accountLinks.forEach((link) => {
    link.setAttribute("href", "/pages/account");
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", kamanoUpdateAccountLinks);
} else {
  kamanoUpdateAccountLinks();
}
